import { Controller } from "@hotwired/stimulus"

// Zeigt den Lohnanteil genau dann, wenn die Kostenart nach § 35a EStG "gemischt" ist
// (GB-26). Jede andere Kostenart ist ganz oder gar nicht begünstigt und braucht keinen
// Prozentsatz — Billing::LineItem weist einen dort auch zurück.
//
// Versteckt UND deaktiviert, dieselbe Regel wie im billing-line-item-type-Controller:
// ein bloß verstecktes Feld wird trotzdem mitgeschickt, und der Server sähe einen
// Lohnanteil an einer Zeile, die keinen tragen darf. Versteckt wird der Wrapper, nicht
// das Feld: die Kostenart ist ein SlimSelect und rendert eigenes Markup daneben.
export default class extends Controller {
  static targets = ["typeSelect", "shareField"]
  static values = { mixed: String }

  connect() {
    this.apply()
  }

  typeChanged() {
    this.apply()
  }

  apply() {
    if (!this.hasShareFieldTarget) return

    const mixed = this.hasTypeSelectTarget && this.typeSelectTarget.value === this.mixedValue
    this.shareFieldTarget.classList.toggle("hidden", !mixed)
    this.shareFieldTarget.querySelectorAll("input, select").forEach((input) => {
      input.disabled = !mixed
    })
  }
}
